export function _useProductListingFilter() {
  const isActive = ref(false);
  const show = () => {
    isActive.value = true;
  };

  const hide = () => {
    isActive.value = false;
  };

  return {
    isActive: computed(() => isActive.value),
    show,
    hide,
  };
}

export const useProductListingFilter = createSharedComposable(
  _useProductListingFilter
);
